import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import greenTick from "../../../../assets/images/generic/teenyicons_tick-circle-outline-green.svg";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import { atleast1Digit, atleast1LowerChar, atleast1SplChar, atleast1UpperChar, LimitCharBetweenSixFifty, } from "@frameworks/web/utils/regex";
const passwordmsg = " Special characters not allowed are: ( ) < > ? , % - + : ; [ ] { } | ~ ‘ ^ _ “ / $";
export const passwordError = (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "helpText" }, "Password cannot be the same as login ID"),
    React.createElement("div", { className: "passwordContainer" },
        React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("img", { src: greenTick })),
            React.createElement("span", { className: "labelcontain green" }, "6-12 characters")),
        React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("i", { className: "edel-icon-rounded-close" })),
            React.createElement("span", { className: "labelcontain" }, "1 uppercase")),
        React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("i", { className: "edel-icon-rounded-close" })),
            React.createElement("span", { className: "labelcontain" }, "1 lowercase")),
        React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("i", { className: "edel-icon-rounded-close" })),
            React.createElement("span", { className: "labelcontain" }, "1 alpha numeric character")),
        React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("i", { className: "edel-icon-rounded-close" })),
            React.createElement("span", { className: "labelcontain" }, "1 special character"),
            React.createElement("span", null,
                React.createElement(OverlayTrigger, { trigger: ["hover", "focus"], placement: "bottom", overlay: React.createElement(Popover, { id: `popover-password-top` },
                        React.createElement(Popover.Body, { className: "dash-popover-body p-2" },
                            React.createElement("p", { className: "dash-toolbody mb-0 DMSansNormal_12_400" }, passwordmsg))) },
                    React.createElement("span", { className: "rounded-circle1 exclamation1" },
                        React.createElement("i", { className: "edel-icon-info" }))))))));
export const PasswordValidationObject = [
    { name: "6-12 characters", value: false, regex: LimitCharBetweenSixFifty },
    { name: "1 uppercase", value: false, regex: atleast1UpperChar },
    { name: "1 lowercase", value: false, regex: atleast1LowerChar },
    { name: "1 alpha numeric character", value: false, regex: atleast1Digit },
    {
        name: " 1 special character",
        value: false,
        regex: atleast1SplChar,
        isOverLay: (React.createElement("div", null,
            React.createElement(OverlayTrigger, { trigger: ["hover", "focus"], placement: "bottom", overlay: React.createElement(Popover, { id: `popover-password-top` },
                    React.createElement(Popover.Body, { className: "dash-popover-body p-2" },
                        React.createElement("p", { className: "dash-toolbody mb-0 DMSansNormal_12_400" }, passwordmsg))) },
                React.createElement(React.Fragment, null,
                    React.createElement(GenericTooltip, { triggerType: "hover", placement: "bottom", button: React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "ps-3 common-info-icon-section info-icon-small hand_cursor" },
                                React.createElement("div", { className: "mk-card-topright d-flex align-items-center common-info-icon " },
                                    React.createElement("span", { className: "rounded-circle exclamation" },
                                        React.createElement("i", { className: "edel-icon-info" }))))), toolTipClassName: "blue-common-tooltip ", externalClassName: "common-tooltip ", toolTipText: "Special characters not allowed are: ( ) < > ? , % - + : ; [ ] { } | ~ ‘ ^ _ “ / $" }))))),
    },
];
